import { AutogenLayoutPayAdjustmentHistoryList } from "./autogen/AutogenLayoutPayAdjustmentHistoryList";
import { Layout, TableRowDisplayEvent, Textbox } from "@mcleod/components";

export class PayAdjustmentHistoryList extends AutogenLayoutPayAdjustmentHistoryList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [
            { field: "check_date", sort: "desc" },
            { field: "payee_id", sort: "asc" },
            { field: "check_number", sort: "asc" },
            { field: "order_id", sort: "asc" }
        ];
    }

    tablePayAdjustmentHistoryOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const textboxOrderId = tableRow.findComponentById("textboxOrderId") as Textbox;
        if (textboxOrderId) {
            textboxOrderId.quickInfoOverrideMethod = async () => {
                return Layout.getLoadedLayoutWithData("lme/settlement/OrderPayablesOrderIdQuickInfo", null, tableRow.data.get("movement_id"));
            }
        }
    }
}
